import type { IValidationResult, IValidatorParams } from "@edaz/services/baseValidationService";
import type { NumberRange } from "@edaz/edazkit/NumberRangeInput";

export interface IsNumberRangeOptions {
  min?: number;
  max?: number;
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export default function isNumberRange(
  value?: NumberRange,
  options?: IsNumberRangeOptions,
  params?: IValidatorParams
): IValidationResult {
  if (options?.min !== undefined && options.max !== undefined && options.min > options.max) {
    throw new Error("Given options interval is invalid");
  }

  if (value) {
    if (value.from !== undefined && value.to !== undefined && value.from > value.to) {
      return {
        isValid: false,
        errors: {
          constraints: {
            isInterval: "false",
          },
        },
      };
    }

    if (
      options?.min !== undefined &&
      ((value.from !== undefined && value.from < options.min) ||
        (value.from === undefined && value.to !== undefined && value.to < options.min))
    ) {
      return {
        isValid: false,
        errors: {
          constraints: {
            minimum: "false",
          },
          params: [`${options.min}`],
        },
      };
    }

    if (
      options?.max !== undefined &&
      ((value.to !== undefined && value.to > options.max) ||
        (value.to === undefined && value.from !== undefined && value.from > options.max))
    ) {
      return {
        isValid: false,
        errors: {
          constraints: {
            maximum: "false",
          },
          params: [`${options.max}`],
        },
      };
    }
  }

  return {
    isValid: true,
  };
}
